import { compareGroupPrecedence } from '@/utils/dueDiligence/groupPrecedence.js'

function sortGroups (state) {
  state.mitigationGroups.sort(compareGroupPrecedence)
}

export default {
  setMitigationGroups (state, mitigationGroups) {
    state.mitigationGroups = mitigationGroups
  },

  setMitigationGroupsLoading (state, loading) {
    state.loading = loading
  },

  addMitigationGroup (state, mitigationGroup) {
    state.mitigationGroups.push(mitigationGroup)
    sortGroups(state)
  },

  removeMitigationGroup (state, mitigationGroupId) {
    state.mitigationGroups = state.mitigationGroups.filter(g => g.mitigationGroupId !== mitigationGroupId)
  },

  updateMitigationGroup (state, mitigationGroup) {
    const index = state.mitigationGroups.findIndex(g => g.mitigationGroupId === mitigationGroup.mitigationGroupId)
    if (index !== -1) {
      Object.assign(state.mitigationGroups[index], mitigationGroup)
      sortGroups(state)
    }
  }
}
